import SchoolAssociationsEditWrapper from './SchoolAssociationsEditWrapper.page';

export default SchoolAssociationsEditWrapper;